import type React from 'react'

interface DividerWithTextProps extends React.HTMLAttributes<HTMLDivElement> {
  text: string
}

export function DividerWithText({
  className,
  text,
  ...props
}: Readonly<DividerWithTextProps>) {
  return (
    <div className={`flex items-center ${className || ''}`} {...props}>
      <div className="flex-1 border-t-2 border-gray-200"></div>
      <span className="px-2 text-sm font-medium text-gray-500">{text}</span>
      <div className="flex-1 border-t-2 border-gray-200"></div>
    </div>
  )
}

export default DividerWithText
